import { Form, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { FormCheckbox, FormInput, FormRadioButton, FormSelector } from '../../FormElements';
import FormObserver from '../../FormElements/FormObserver';
import { Button } from '../../Elements';
import { useDispatch, useSelector } from 'react-redux';
import commonNetwork from '../../../../common/api/commonNetwork';
import { ThunkDispatch } from 'redux-thunk';
import { getBankList } from '../../../../store/slices/bankListSlice';
import { getErpParameters } from '../../../../store/slices/erpParameterSlice';
import { getParameters } from '../../../../store/slices/parametersSlice';
import { toast } from 'react-toastify';
import appHelpers from '../../../../common/helpers/appHelpers';
import { erpLogoParameters } from '../../../../constants/options/erpLogoParameters';
import { currencySymbole } from '../../../../constants/options/currencySymbole';
import { erpNetsisParameters } from '../../../../constants/options/erpNetsisParameters';
import { exchangeType } from '../../../../constants/options/exchangeType';
import { FormCheckBoxModel } from '../../../../common/types/FormCheckBoxModel';
import { erpSettingsSchema } from '../../../../common/validators/erpSettingsSchema';
import { receiptStatus } from '../../../../constants/options/receiptStatus';
import { FormControlLabel, Switch } from '@mui/material';
import { FieldTooltip } from '../../Elements/FieldTooltip';
import { ApiResponseType } from '../../../../common/api/apiHelper';

interface ErpSettingsProps {
    erpParameters: any,
    parameters: any,
    divisionList: any,
    departmentList: any

}

const ErpSettings: React.FC<ErpSettingsProps> = ({
    erpParameters,
    parameters,
    divisionList,
    departmentList
}) => {

    const initialValues = {
        erpType: erpParameters.erpType || "",
        projectCode: erpParameters.projectCode || "",
        salesmanCode: erpParameters.salesmanCode || "",
        customerSyncFilter: erpParameters?.customerSyncFilter || "",
        customerBalanceSql: erpParameters.customerBalanceSql || "",
        erpServiceUrl: erpParameters.erpServiceUrl || "",
        status: erpParameters.status == null ? true : erpParameters.status,
        customerbalanceChecked: erpParameters?.customerbalanceChecked == null ? true : erpParameters.customerbalanceChecked,
        paymentsyncCheckbox: erpParameters?.paymentsyncCheckbox == null ? true : erpParameters.paymentsyncCheckbox,
        autoPaymentsyncChecked: erpParameters?.autoPaymentsyncChecked,
        customersyncChecked: erpParameters?.customersyncChecked == null ? true : erpParameters?.customersyncChecked,
        isCustomerSyncFullQuery: erpParameters?.isCustomerSyncFullQuery,
        isErpSalesmanMatch: erpParameters?.isErpSalesmanMatch == null ? true : erpParameters?.isErpSalesmanMatch,
        isCustomerSalesmanCode: erpParameters?.isCustomerSalesmanCode,
        isexchangeon: erpParameters?.isexchangeon,
        erpExchangeSymbol: (erpParameters?.erpExchangeSymbol)?.trim(),
        erpExchangeTypeNo: erpParameters?.erpExchangeTypeNo,
        erpExchangeType: (erpParameters?.erpExchangeType)?.trim(),
        logoParams: {
            authCode: erpParameters.logoParams.authCode || "",
            erpAuxcilCode: erpParameters.logoParams.erpAuxcilCode || "",
            departmentCode: erpParameters.logoParams.departmentCode || "",
            divisionCode: erpParameters.logoParams.divisionCode || "",
            synctypeid: erpParameters?.logoParams?.synctypeid ? String(erpParameters?.logoParams?.synctypeid) : "3",
            erpFirmCode: erpParameters.logoParams.erpFirmCode || "",
            erpUserName: erpParameters.logoParams.erpUserName || "",
            erpPassword: erpParameters.logoParams.erpPassword || "",
            isTransactionItemCardHolderName: erpParameters?.logoParams?.isTransactionItemCardHolderName,
            affectRisk: erpParameters?.logoParams?.affectRisk,
            receiptStatus: erpParameters?.logoParams?.receiptStatus || "gerçek",
            isSendDocNumber: erpParameters?.logoParams?.isSendDocNumber,
            isErpDivisionMatch: erpParameters?.logoParams?.isErpDivisionMatch == null ? true : erpParameters?.logoParams?.isErpDivisionMatch,
        },
        netsisParams: {
            cashDocument: erpParameters?.netsisParams?.cashDocument,
            referenceCode: erpParameters?.netsisParams?.referenceCode || "",
            receiptSerialNo: erpParameters.netsisParams.receiptSerialNo || "",
            synctypeid: erpParameters?.netsisParams?.synctypeid ? String(erpParameters?.netsisParams?.synctypeid) : "2",
            isInstallmentRefraction: erpParameters?.netsisParams?.isInstallmentRefraction,
            erpFirm: erpParameters.netsisParams.erpFirm || "",
            erpFirmCode: erpParameters.netsisParams.erpFirmCode || "",
            erpBranchCode: erpParameters.netsisParams.erpBranchCode || "",
            erpUserName: erpParameters.netsisParams.erpUserName || "",
            erpPassword: erpParameters.netsisParams.erpPassword || "",
            dbType: erpParameters.netsisParams.dbType || "vtMSSQL",
            dbUserName: erpParameters.netsisParams.dbUserName || "",
            dbPassword: erpParameters.netsisParams.dbPassword || "",
            bankToAccountChecked: erpParameters?.netsisParams?.bankToAccountChecked,
            isCustomerProjectCode: erpParameters?.netsisParams?.isCustomerProjectCode,
            customerProjectCodeColumn: erpParameters.netsisParams.customerProjectCodeColumn || ""
        },
        bankMatchList: [
            {
                bankId: 0,
                erpBankCode: "",
            },
        ],
    };

    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

    const [formValues, setFormValues] = useState(initialValues);
    const [isloadingParameters, setIsloadingParameters] = useState(false);
    const [logoFormCheckBox, setLogoFormCheckBox] = useState<FormCheckBoxModel[]>([]);
    const [netsisFormCheckBox, setNetsisFormCheckBox] = useState<FormCheckBoxModel[]>([]);
    const [connectionLoading, setConnectionLoading] = useState<boolean>(false);

    const { projectCodes, salesmanCodes, specialCodes, authCodes, referenceCodes, dekontSerialCodes } = useSelector((state: any) => state.erpParameters);

    useEffect(() => {
        handleFormCheckBoxParameters();
    }, [
        formValues?.logoParams?.synctypeid,
        formValues?.netsisParams?.synctypeid,
        formValues.erpType
    ])

    const platform = appHelpers.getPlatform();
    const isWebPlatform = platform == "web";

    const getErpType = () => {
        if (isWebPlatform) {
            return formValues.erpType || parameters.erpType
        } else if (platform !== "NETSIS") {
            return 2;
        } else {
            return 1;
        }
    }

    const onSubmit = async () => {
        try {
            setIsloadingParameters(true);
            var erpType = getErpType(); //1 netsis, 2 logo
            const paramsLogo = {
                erpType: erpType, //1 netsis, 2 logo
                erpFirmCode: formValues.logoParams.erpFirmCode,
                erpUserName: formValues.logoParams.erpUserName,
                erpUserPassword: formValues.logoParams.erpPassword,
                erpServiceUrl: formValues.erpServiceUrl,
                projectCode: formValues.projectCode,
                salesmanCode: formValues.salesmanCode,
                customerSyncFilter: formValues.customerSyncFilter,
                customerBalanceSql: formValues.customerBalanceSql,
                customersyncChecked: formValues.customersyncChecked,
                customerbalanceChecked: formValues.customerbalanceChecked,
                status: formValues.status,
                autoPaymentsyncChecked: formValues.autoPaymentsyncChecked,
                paymentsyncCheckbox: formValues.paymentsyncCheckbox,
                isCustomerextractOn: false,
                isCustomerSyncFullQuery: formValues.isCustomerSyncFullQuery,
                isErpSalesmanMatch: formValues.isErpSalesmanMatch,
                isCustomerSalesmanCode: formValues.isCustomerSalesmanCode,
                isexchangeon: formValues.isexchangeon,
                erpExchangeSymbol: formValues.erpExchangeSymbol,
                erpExchangeTypeNo: formValues.erpExchangeTypeNo,
                erpExchangeType: formValues.erpExchangeType,
                logoParams: {
                    authCode: formValues.logoParams.authCode,
                    erpAuxcilCode: formValues.logoParams.erpAuxcilCode,
                    departmentCode: formValues.logoParams.departmentCode,
                    divisionCode: formValues.logoParams.divisionCode,
                    synctypeid: parseInt(formValues.logoParams.synctypeid),
                    erpFirmCode: formValues.logoParams.erpFirmCode,
                    erpUserName: formValues.logoParams.erpUserName,
                    erpPassword: formValues.logoParams.erpPassword,
                    isTransactionItemCardHolderName: formValues.logoParams.isTransactionItemCardHolderName,
                    affectRisk: formValues.logoParams.affectRisk,
                    receiptStatus: formValues.logoParams.receiptStatus,
                    isSendDocNumber: formValues.logoParams.isSendDocNumber,
                    isErpDivisionMatch: formValues.logoParams.isErpDivisionMatch,
                },
            };

            const paramsNetsis = {
                erpType: erpType, //1 netsis, 2 logo
                erpFirm: formValues.netsisParams.erpFirm,
                erpFirmCode: formValues.netsisParams.erpFirmCode,
                erpServiceUrl: formValues.erpServiceUrl,
                erpUserName: formValues.netsisParams.erpUserName,
                erpUserPassword: formValues.netsisParams.erpPassword,
                erpBranchCode: formValues.netsisParams.erpBranchCode,
                dbType: formValues.netsisParams.dbType,
                dbUser: formValues.netsisParams.dbUserName,
                dbPassword: formValues.netsisParams.dbPassword,
                projectCode: formValues.projectCode,
                salesmanCode: formValues.salesmanCode,
                customerSyncFilter: formValues.customerSyncFilter,
                customerBalanceSql: formValues.customerBalanceSql,
                customerbalanceChecked: formValues.customerbalanceChecked,
                customersyncChecked: formValues.customersyncChecked,
                status: formValues.status,
                paymentsyncCheckbox: formValues.paymentsyncCheckbox,
                autoPaymentsyncChecked: formValues.autoPaymentsyncChecked,
                isCustomerextractOn: false,
                isCustomerSyncFullQuery: false,
                isErpSalesmanMatch: formValues.isErpSalesmanMatch,
                isCustomerSalesmanCode: formValues.isCustomerSalesmanCode,
                isexchangeon: formValues.isexchangeon,
                erpExchangeSymbol: formValues.erpExchangeSymbol,
                erpExchangeTypeNo: formValues.erpExchangeTypeNo,
                erpExchangeType: formValues.erpExchangeType,
                netsisParams: {
                    cashDocument: parseInt(formValues.netsisParams.synctypeid) === 1 ? "Kasa" : "Dekont",
                    referenceCode: formValues.netsisParams.referenceCode,
                    receiptSerialNo: formValues.netsisParams.receiptSerialNo,
                    synctypeid: parseInt(formValues.netsisParams.synctypeid),
                    isInstallmentRefraction: formValues.netsisParams.isInstallmentRefraction,
                    erpFirmCode: formValues.netsisParams.erpFirmCode,
                    erpFirm: formValues.netsisParams.erpFirm,
                    erpBranchCode: formValues.netsisParams.erpBranchCode,
                    erpUserName: formValues.netsisParams.erpUserName,
                    erpPassword: formValues.netsisParams.erpPassword,
                    bankToAccountChecked: formValues.netsisParams.bankToAccountChecked,
                    isCustomerProjectCode: formValues.netsisParams.isCustomerProjectCode,
                    customerProjectCodeColumn: formValues.netsisParams.customerProjectCodeColumn
                },
            };

            const response = await commonNetwork.post(
                "/parameters/saveErpParameters-v1",
                erpType === 1 ? paramsNetsis : paramsLogo
            );

            if (response.isSuccess) {
                dispatch(getBankList());
                dispatch(getErpParameters());
                dispatch(getParameters());
                toast.success("Kayıt işlemi başarılı");
            } else {
                toast.error("Kayıt işlemi başarısız");
            }
        } catch (error) {

        } finally {
            setIsloadingParameters(false);
        }
    };

    const getErpParameterInput = (label: any, name: any, selectOptions: any, value: any, maxLength?: number) => {

        if (isWebPlatform) {

            return (
                <FormInput
                    label={label}
                    name={name}
                    value={value === null ? "" : value}
                    maxLength={maxLength}
                // labelInfoIcon={
                //     <FieldTooltip title={""}
                //         content={"..."} />
                // }
                />
            );
        } else {
            return (
                <FormSelector
                    label={label}
                    name={name}
                    options={selectOptions}
                    value={selectOptions?.find((s: any) => s.value == value)}
                    isClearable
                // labelInfoIcon={
                //     <FieldTooltip title={""}
                //         content={"..."} />
                // }
                />
            );
        }
    }

    const erpList = [
        { label: "Logo Tiger", value: 2 },
        { label: "Logo Netsis", value: 1 },
    ];

    const getWebPlatformValues = () => {

        const erpType = getErpType();

        if (erpType == 1) {
            return (
                <>
                    <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                        <div className="mt-1">
                            <FormInput
                                label="Servis URL"
                                name="erpServiceUrl"
                                maxLength={201}
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                        <div className="mt-1">
                            <FormInput
                                label="Firma Adı"
                                name="netsisParams.erpFirm" //netsisParams.erpFirm
                                value={formValues.netsisParams.erpFirm === null ? "" : formValues.netsisParams.erpFirm}
                                maxLength={51}
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                        <div className="mt-3">

                            <FormInput
                                label="İşletme Kodu"
                                name="netsisParams.erpFirmCode"
                                maxLength={51}
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                        <div className="mt-3 ">
                            <FormInput
                                label="Şube Kodu"
                                name="netsisParams.erpBranchCode"
                                value={formValues.netsisParams.erpBranchCode === null ? "" : formValues.netsisParams.erpBranchCode}
                                maxLength={21}
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                        <div className="mt-3">

                            <FormInput
                                label="ERP Kullanıcı Adı"
                                name="netsisParams.erpUserName"
                                maxLength={21}
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                        <div className="mt-3 ">
                            <FormInput
                                label="ERP Kullanıcı Şifresi"
                                name="netsisParams.erpPassword"
                                maxLength={21}
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                        <div className="mt-3">

                            <FormInput
                                label="Veritabanı Tipi"
                                name="netsisParams.dbType"
                                maxLength={11}
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                        <div className="mt-3 ">
                            <FormInput
                                label="Veritabanı Kullanıcı Adı"
                                name="netsisParams.dbUserName"
                                maxLength={21}
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                        <div className="mt-3">

                            <FormInput
                                label="Veritabanı Kullanıcı Şifresi"
                                name="netsisParams.dbPassword"
                                maxLength={21}
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                        <div className='mt-9 flex  flex-row-reverse'>
                            <Button
                                size="xl"
                                color="gray"
                                hover="gray"
                                type='button'
                                loading={connectionLoading}
                                callback={() => {
                                    checkTheConnection();
                                }}
                            >
                                Bağlantıyı Kontrol Et
                            </Button>
                        </div>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                        <div className="mt-1">
                            <FormInput
                                label="Servis URL"
                                name="erpServiceUrl"
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                        <div className="mt-1">
                            <FormInput
                                label="Firma Kodu"
                                name="logoParams.erpFirmCode"
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 ">
                        <div className="mt-3">
                            <FormInput
                                label="ERP Kullanıcı Adı"
                                name="logoParams.erpUserName"
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                        <div className="mt-3 ">
                            <FormInput
                                label="ERP Kullanıcı Şifresi"
                                name="logoParams.erpPassword"
                            // labelInfoIcon={
                            //     <FieldTooltip title={""}
                            //         content={"..."} />
                            // }
                            />
                        </div>
                    </div>
                    <div className=' mt-5 flex flex-row-reverse'>
                        <Button
                            size="xl"
                            color="gray"
                            hover="gray"
                            type='button'
                            loading={connectionLoading}
                            callback={() => {
                                checkTheConnection();
                            }}
                        >
                            Bağlantıyı Kontrol Et
                        </Button>
                    </div>
                </>
            );
        }
    }
    const erpType = getErpType();

    const handleFormCheckBoxParameters = () => {

        if (formValues.erpType == "2") {
            setLogoFormCheckBox(erpLogoParameters);
        } else {
            if (formValues.netsisParams.synctypeid === "1" || formValues.netsisParams.synctypeid === "4") {
                setNetsisFormCheckBox(erpNetsisParameters.filter(item => item.tier !== 2));
            }
            if (formValues.netsisParams.synctypeid === "2") {
                setNetsisFormCheckBox(erpNetsisParameters);
            }
        }
    }

    const getIsExchangeOn = () => {
        return (
            <>
                {(formValues.isexchangeon === true) ?
                    <>
                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                            <div className="mt-4">
                                <FormInput
                                    label="ERP Döviz Çevrim Tipi"
                                    name="erpExchangeTypeNo"
                                    type="text"
                                    mask="99"
                                // labelInfoIcon={
                                //     <FieldTooltip title={""}
                                //         content={"..."} />
                                // }
                                />
                            </div>
                        </div>
                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                            <div className="mt-3">
                                <FormSelector
                                    label="ERP Çevrim Kur Tipi"
                                    placeholder="Baz Alınacak Döviz Tipini Seçiniz"
                                    options={exchangeType}
                                    name="erpExchangeType"
                                    value={formValues.erpExchangeType ? exchangeType.find(item => item.value == formValues.erpExchangeType) : null}
                                // labelInfoIcon={
                                //     <FieldTooltip title={""}
                                //         content={"..."} />
                                // }
                                />
                            </div>
                        </div>
                        {(formValues.erpType === 1) ?
                            <>
                                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                    <div className="mt-3">
                                        <FormSelector
                                            label="Döviz Tipi Sembolü"
                                            placeholder="Döviz Sembolünü Seçiniz"
                                            options={currencySymbole}
                                            name="erpExchangeSymbol"
                                            value={formValues.erpExchangeSymbol ? currencySymbole.find(item => item.value == formValues.erpExchangeSymbol) : null}
                                        // labelInfoIcon={
                                        //     <FieldTooltip title={""}
                                        //         content={"..."} />
                                        // }

                                        />
                                    </div>
                                </div>
                            </>
                            : null}
                    </> : null}
            </>
        )
    }

    const checkTheConnection = async () => {
        try {
            setConnectionLoading(true);
            if (erpType == 1) {
                const parameters = {
                    erpId: formValues.erpType,
                    erpServiceUrl: formValues.erpServiceUrl,
                    erpBranchCode: formValues.netsisParams.erpBranchCode,
                    erpUserName: formValues.netsisParams.erpUserName,
                    erpPassword: formValues.netsisParams.erpPassword,
                    dbType: formValues.netsisParams.dbType,
                    erpFirm: formValues.netsisParams.erpFirm,
                    erpFirmCode: formValues.logoParams.erpFirmCode,
                    dbUser: formValues.netsisParams.dbUserName,
                    dbPassword: formValues.netsisParams.dbPassword
                }

                var result: any = await commonNetwork.post("/integration/check-erp-connection", parameters);

                if (result.isSuccess) {
                    toast.success("Bağlantı Başarılı: " + result.data.returnResult)
                } else {
                    toast.error("Bağlantı Başarısız.")
                }
            } else {
                const parameters = {
                    erpId: formValues.erpType,
                    erpServiceUrl: formValues.erpServiceUrl,
                    erpUserName: formValues.logoParams.erpUserName,
                    erpPassword: formValues.logoParams.erpPassword,
                    erpFirmCode: formValues.logoParams.erpFirmCode,
                }
                var result: any = await commonNetwork.post("/integration/check-erp-connection", parameters);

                if (result.isSuccess) {
                    toast.success("Bağlantı Başarılı: " + result.data.returnResult)
                } else {
                    toast.error("Bağlantı başarısız.")
                }
            }
        } catch (error) {

        } finally {
            setConnectionLoading(false);
        }
    }

    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={formValues}
                onSubmit={onSubmit}
                validationSchema={erpSettingsSchema}
            >
                {({
                    values,
                    setFieldValue,
                }) => (
                    <Form>
                        <FormObserver
                            watch={(val: any) => {
                                setFormValues(val);
                            }}
                        />
                        <>
                            <div className="px-4  py-2  bg-white shadow-md space-y-4  mt-2 my-1 rounded-md">
                                <div className=" px-3 mt-3 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3 ">
                                    <div className="mt-1">
                                        <h1 className="font-bold text-contrast-90">
                                            ERP Seçimi
                                        </h1>
                                        <span className="text-contrast-50 text-md">
                                            Kullanmış olduğunuz ERP uygulamasını seçiniz. ERP entegrasyonu sağlamak istiyorsanız, ERP entegrasyon durumunu "aktif" hale getirmeyi unutmayın.
                                        </span>
                                    </div>
                                    <div className="w-full  col-span-2">

                                        {isWebPlatform && (
                                            <>
                                                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2 mb-3">
                                                    <div className="">
                                                        <FormSelector
                                                            label="ERP Uygulaması"
                                                            name="erpType"
                                                            options={erpList}
                                                            value={erpList.find(w => w.value == formValues.erpType)}
                                                            onChange={setFieldValue}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className=''>
                                                        <FormControlLabel
                                                            className={`flex flex-row justify-end font-small ${formValues.status == true ? "text-success-blue" : "text-gray-400"}`}
                                                            style={{
                                                                marginRight: 0,
                                                                marginLeft: -10,
                                                            }}
                                                            label={<p >{formValues.status ? "ERP Entegrasyon Durumu Aktif" : "ERP Entegrasyon Durumu Pasif"}</p>}
                                                            control={
                                                                <Switch
                                                                    style={{
                                                                        marginRight: 0,
                                                                    }}
                                                                    defaultChecked={formValues.status}
                                                                    checked={formValues.status}
                                                                    onChange={(e) => {
                                                                        setFormValues(prevValues => ({
                                                                            ...prevValues,
                                                                            status: !formValues.status
                                                                        }))
                                                                    }}
                                                                />
                                                            }>
                                                        </FormControlLabel>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                <hr />
                                <div className=" px-3 mt-3 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3  mb-10 ">
                                    <div className="mt-1">
                                        <h1 className="font-bold text-contrast-90">
                                            Bağlantı Bilgileri
                                        </h1>
                                        <span className="text-contrast-50 text-md">
                                            ERP entegrasyon durumunu aktif hale getirdiyseniz, bağlantı bilgileri alanlarını doldurunuz. Bağlantı bilgilerini doldurduktan sonra "Bağlantıyı Kontrol Et" butonuna tıklayarak bağlantı testi yapabilirsiniz. Etahsilat'ı ERP uygulamanıza bağlayabilmek için bağlantı bilgilerinizin eksiksiz ve doğru olması gerekmektedir.
                                        </span>
                                    </div>

                                    {erpType != 1 ? ( //Netsis

                                        <div className="w-full  col-span-2">
                                            {isWebPlatform && getWebPlatformValues()}
                                        </div>
                                    ) : (

                                        <div className="w-full  col-span-2">
                                            {isWebPlatform && getWebPlatformValues()}
                                        </div>
                                    )}
                                </div>

                                <hr />

                                <div className=" px-3 mt-3 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3  mb-10 ">
                                    <div className="mt-1">
                                        <h1 className="font-bold text-contrast-90">
                                            ERP Entegrasyonları
                                        </h1>
                                        <span className="text-contrast-50 text-md">
                                            Kullanmak istediğiniz ERP entegrasyonlarını aktif hale getiriniz.
                                        </span>
                                    </div>
                                    <div className='w-full col-span-2'>
                                        <div className="grid grid-cols-2 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                            <div className='mt-1'>
                                                <FormControlLabel
                                                    className={`flex flex-row justify-end font-small ${formValues.customersyncChecked == true ? "text-success-blue" : "text-gray-400"}`}
                                                    style={{
                                                        marginRight: 0,
                                                        marginLeft: -10
                                                    }}
                                                    label={<p>{formValues.customersyncChecked ? "Müşteri Kartı Entegrasyonu Aktif" : "Müşteri Kartı Entegrasyonu Pasif"}</p>}
                                                    control={
                                                        <Switch
                                                            style={{
                                                                marginRight: 0,
                                                            }}
                                                            defaultChecked={formValues.customersyncChecked}
                                                            checked={formValues.customersyncChecked}
                                                            onChange={() => {
                                                                setFormValues(prevValues => ({
                                                                    ...prevValues,
                                                                    customersyncChecked: !formValues.customersyncChecked
                                                                }))
                                                            }}
                                                        />
                                                    }
                                                >
                                                </FormControlLabel>
                                            </div>
                                        </div>
                                        {isWebPlatform && (
                                            <div className="flex flex-row mt-1 w-full">
                                                <div className={erpType == 2 ? "mt-1 w-[75%]" : "mt-1 w-full -mr-3"}>
                                                    <FormInput
                                                        label={"Müşteri Entegrasyon Filtresi"}
                                                        name={"customerSyncFilter"}
                                                        maxLength={501}
                                                        disabled={!formValues.customersyncChecked}
                                                    // labelInfoIcon={
                                                    //     <FieldTooltip title={""}
                                                    //         content={"..."} />
                                                    // }
                                                    />
                                                </div>
                                                <div className='mt-9 ml-3'>
                                                    {erpType == 2 ? <FormCheckbox
                                                        name="isCustomerSyncFullQuery"
                                                        label="Tam SQL Sorgusunu Gir"
                                                        type="checkbox"
                                                        disabled={!formValues.customersyncChecked}
                                                    /> : ""}
                                                </div>
                                            </div>)}
                                        <div className="grid grid-cols-2 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                            <div className='mt-2'>
                                                <FormControlLabel
                                                    className={`flex flex-row justify-end font-small ${formValues.customerbalanceChecked == true ? "text-success-blue" : "text-gray-400"}`}
                                                    style={{
                                                        marginRight: 0,
                                                        marginLeft: -10
                                                    }}
                                                    label={<p>{formValues.customerbalanceChecked ? "Müşteri Bakiye Entegrasyonu Aktif" : "Müşteri Bakiye Entegrasyonu Pasif"}</p>}
                                                    control={
                                                        <Switch
                                                            style={{
                                                                marginRight: 0,
                                                            }}
                                                            defaultChecked={formValues.customerbalanceChecked}
                                                            checked={formValues.customerbalanceChecked}
                                                            onChange={() => {
                                                                setFormValues(prevValues => ({
                                                                    ...prevValues,
                                                                    customerbalanceChecked: !formValues.customerbalanceChecked
                                                                }))
                                                            }}
                                                        />
                                                    }
                                                >
                                                </FormControlLabel>
                                            </div>
                                        </div>
                                        {isWebPlatform && (
                                            <div className="mt-1 w-full">
                                                <FormInput
                                                    label={"Cari Bakiye Sorgusu"}
                                                    name={"customerBalanceSql"}
                                                    maxLength={501}
                                                    disabled={!formValues.customerbalanceChecked}
                                                // labelInfoIcon={
                                                //     <FieldTooltip title={""}
                                                //         content={"..."} />
                                                // }
                                                />
                                            </div>)}
                                        <div className='mt-2'>
                                            <FormControlLabel
                                                className={`flex flex-row justify-end font-small ${formValues.paymentsyncCheckbox == true ? "text-success-blue" : "text-gray-400"}`}
                                                style={{
                                                    marginRight: 0,
                                                    marginLeft: -10
                                                }}
                                                label={<p>{formValues.paymentsyncCheckbox ? "Ödeme Fişi Entegrasyonu Aktif" : "Ödeme Fişi Entegrasyonu Pasif"}</p>}
                                                control={
                                                    <Switch
                                                        style={{
                                                            marginRight: 0,
                                                        }}
                                                        defaultChecked={formValues.paymentsyncCheckbox}
                                                        checked={formValues.paymentsyncCheckbox}
                                                        onChange={() => {
                                                            setFormValues(prevValues => ({
                                                                ...prevValues,
                                                                paymentsyncCheckbox: !formValues.paymentsyncCheckbox
                                                            }))
                                                        }}
                                                    />
                                                }
                                            >
                                            </FormControlLabel>
                                        </div>
                                        {formValues.paymentsyncCheckbox ?
                                            <>
                                                {erpType != 1 ? (
                                                    <>
                                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-1 xl:grid-cols-1 ">
                                                            <div className="mt-3">
                                                                <div className="flex  pr-6 text-contrast-70 ">
                                                                    <span>
                                                                        ERP Fiş Tipi: {" "}
                                                                    </span>
                                                                    <div className="items-center text-center mt-1 ml-4">
                                                                        <FormRadioButton
                                                                            items={[
                                                                                { label: "Kredi Kartı Fişi", value: "3" },
                                                                                { label: "Virman Fişi", value: "5" },
                                                                            ]}
                                                                            name="logoParams.synctypeid"
                                                                            checked={formValues?.logoParams?.synctypeid}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-1 xl:grid-cols-1 ">
                                                            <div className="mt-3">
                                                                <div className="flex  pr-6 text-contrast-70 ">
                                                                    <span>
                                                                        ERP Fiş Tipi: {" "}
                                                                    </span>
                                                                    <div className="items-center text-center mt-1 ml-4">
                                                                        <FormRadioButton
                                                                            items={[
                                                                                { label: "Dekont Kaydı", value: "2" },
                                                                                { label: "Kasa Kaydı", value: "1" },
                                                                                { label: "Hızlı Tahsilat", value: "4" },
                                                                            ]}
                                                                            name="netsisParams.synctypeid"
                                                                            checked={formValues?.netsisParams?.synctypeid}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </> : null}

                                        <div className="grid grid-cols-2 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                            <div className='mt-4 pb-2'>
                                                <FormCheckbox
                                                    name="autoPaymentsyncChecked"
                                                    label="Ödeme Sonrası Otomatik Aktarım"
                                                    type="checkbox"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <hr />

                                <div className=" px-3 mt-3 grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3  mb-10 ">
                                    <div className="mt-1">
                                        <h1 className="font-bold text-contrast-90">
                                            ERP Entegrasyon Parametreleri
                                        </h1>
                                        <span className="text-contrast-50 text-md">
                                            ERP entegrasyonu için ekstra parametreler bu alanda yer almaktadır.
                                        </span>
                                    </div>
                                    <div className='w-full col-span-2'>
                                        {erpType == 1 ?
                                            <>
                                                <div className="grid grid-cols-2 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className="mt-1">
                                                        {getErpParameterInput("Varsayılan Proje Kodu", "projectCode", projectCodes, formValues.projectCode, 21)}
                                                    </div>
                                                    <div className="mt-1">
                                                        {getErpParameterInput("Varsayılan Referans Kodu", "netsisParams.referenceCode", referenceCodes, formValues.netsisParams?.referenceCode, 21)}
                                                    </div>
                                                    <div className="mt-1">
                                                        {getErpParameterInput("Varsayılan Satış Temsilcisi Kodu", "salesmanCode", salesmanCodes, formValues?.salesmanCode, 21)}
                                                    </div>

                                                    {
                                                        formValues.netsisParams.synctypeid == "2" &&
                                                        <div className="mt-1">

                                                            {getErpParameterInput("Dekont Seri No", "netsisParams.receiptSerialNo", dekontSerialCodes, formValues.netsisParams?.receiptSerialNo, 21)}
                                                        </div>
                                                    }
                                                </div>
                                                <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className='mt-5'>
                                                        <FormCheckbox
                                                            name="isErpSalesmanMatch"
                                                            label="Satış Temsilci Kodu Kullanıcı Kaydından Okunsun"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className='mt-5'>
                                                        <FormCheckbox
                                                            name="isCustomerSalesmanCode"
                                                            label="Satış Temsilci Kodu Müşteri Kartından Okunsun"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className='mt-5'>
                                                        <FormCheckbox
                                                            name="netsisParams.bankToAccountChecked"
                                                            label="Banka hesabı muhasebe olarak çalışsın mı?"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className='mt-5'>
                                                        <FormCheckbox
                                                            name="netsisParams.isInstallmentRefraction"
                                                            label="Taksit Kırılımında Aktar"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className='mt-5'>
                                                        <FormCheckbox
                                                            name="netsisParams.isCustomerProjectCode"
                                                            label="Proje Kodu Müşteri Kartından Okunsun"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className='grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2'>
                                                    {formValues.netsisParams.isCustomerProjectCode && erpType == 1 ?
                                                        <div className='mt-3'>
                                                            <FormInput
                                                                label="Müşteri Kartı Proje Kodu Veritabanı Alanı"
                                                                name="netsisParams.customerProjectCodeColumn"
                                                                maxLength={51}
                                                            // labelInfoIcon={
                                                            //     <FieldTooltip title={""}
                                                            //         content={"..."} />
                                                            // }
                                                            // maxLength
                                                            />
                                                        </div> : null}
                                                </div>
                                                <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className='mt-5'>
                                                        <FormCheckbox
                                                            name="isexchangeon"
                                                            label="Ödeme Aktarımı Döviz Çevrimi Yapılsın Mı?"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                {getIsExchangeOn()}
                                            </>
                                            :
                                            <>
                                                <div className="grid grid-cols-2 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className="mt-1">
                                                        {getErpParameterInput("İş Yeri Kodu", "logoParams.divisionCode", divisionList, formValues.logoParams.divisionCode)}
                                                    </div>
                                                    <div className="mt-1">
                                                        {getErpParameterInput("Bölüm Kodu", "logoParams.departmentCode", departmentList, formValues.logoParams.departmentCode)}
                                                    </div>
                                                    <div className="mt-1">
                                                        {getErpParameterInput("Proje Kodu", "projectCode", projectCodes, formValues.projectCode, 21)}
                                                    </div>
                                                    <div className="mt-1">
                                                        {getErpParameterInput("Satış Temsilcisi Kodu", "salesmanCode", salesmanCodes, formValues.salesmanCode, 21)}
                                                    </div>
                                                    <div className="mt-1">
                                                        {getErpParameterInput("Yetki Kodu", "logoParams.authCode", authCodes, formValues.logoParams.authCode, 21)}
                                                    </div>
                                                    <div className="mt-1">
                                                        {getErpParameterInput("Özel Kod", "logoParams.erpAuxcilCode", specialCodes, formValues.logoParams.erpAuxcilCode, 51)}
                                                    </div>
                                                    <div className='mt-1'>
                                                        <FormSelector
                                                            label="Fiş Aktarım Durumu"
                                                            name="logoParams.receiptStatus"
                                                            options={receiptStatus}
                                                            value={receiptStatus.filter(i => i.value == formValues.logoParams.receiptStatus)}
                                                        // labelInfoIcon={
                                                        //     <FieldTooltip title={""}
                                                        //         content={"..."} />
                                                        // }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className='mt-5'>
                                                        <FormCheckbox
                                                            name="isErpSalesmanMatch"
                                                            label="Satış Temsilci Kodu Kullanıcı Kaydından Okunsun"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className='mt-5'>
                                                        <FormCheckbox
                                                            name="isCustomerSalesmanCode"
                                                            label="Satış Temsilci Kodu Müşteri Kartından Okunsun"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 gap-4 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className='mt-5'>
                                                        <FormCheckbox
                                                            name="logoParams.isErpDivisionMatch"
                                                            label="İşyeri Kodu Kullanıcı Kaydından Okunsun"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-2 xl:grid-cols-2">
                                                    <div className='mt-6'>
                                                        <FormCheckbox
                                                            name="logoParams.affectRisk"
                                                            label="Risk Etkilensin mi?"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className='grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols2 xl:grid-cols-2'>
                                                    <div className='mt-6'>
                                                        <FormCheckbox
                                                            name="logoParams.isTransactionItemCardHolderName"
                                                            label="Hareket Açıklamaya Kart Sahibinin adı yazılsın mı ?"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className='grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols2 xl:grid-cols-2'>
                                                    <div className='mt-6'>
                                                        <FormCheckbox
                                                            name="logoParams.isSendDocNumber"
                                                            label="Belge Numarası Gönderilsin mi ?"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols2 xl:grid-cols-2">
                                                    <div className='mt-6'>
                                                        <FormCheckbox
                                                            name="isexchangeon"
                                                            label="Ödeme Aktarımı Döviz Çevrimi Yapılsın Mı?"
                                                            type="checkbox"
                                                        />
                                                    </div>
                                                </div>
                                                {getIsExchangeOn()}
                                            </>}
                                    </div>
                                </div>

                                <div className="px-4 py-3  w-full justify-end flex flex-row">
                                    <Button
                                        size="xl"
                                        color="primary"
                                        hover="primary"
                                        type="submit"
                                        loading={isloadingParameters}
                                    >
                                        Kaydet
                                    </Button>
                                </div>
                            </div>
                        </>
                    </Form>
                )}
            </Formik>
        </div >
    )
}

export default ErpSettings;